import React, { useContext, useEffect, useState } from 'react'

import "./catslider.css"
import Navbar from '../Navbar/Navbar'
import Footer from '../footer/Footer'


import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import latest1 from "../../images/latest1.webp"
import latest2 from "../../images/latest2.webp"
import latest3 from "../../images/latest3.webp"
import latest4 from "../../images/latest4.webp"
import latest5 from "../../images/latest5.webp"
import latest6 from "../../images/latest6.webp"
import latest7 from "../../images/latest7.webp"
import latest8 from "../../images/latest8.webp"
import { Shopcontext } from '../../context/Shopcontext';

function Catslider() {

    const { engagementslides, haldislides, mehendislides } = useContext(Shopcontext)

    var catsettings = {
        arrows: true,
        autoplay: true,
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };


    const [engagement, setEngagement] = useState([])
    const [haldi, setHaldi] = useState([])
    const [mehendi, setMehendi] = useState([])

    useEffect(() => {
        haldifunction()
    }, [])


    const haldifunction = () => {
        setEngagement(engagementslides)
        setHaldi(haldislides)
        setMehendi(mehendislides)
    }
    return (
        <>
            <Navbar />

            <div className='catslidermaindiv'>
                <div id='latestslider' className='latestslider'>
                    <div className='subcatheadingdiv'>
                        <h2>Engagement</h2>
                        <div className='catline'></div>
                    </div>
                    <Slider {...catsettings}>
                        {engagement.map((ele, index) => {
                            return (
                                <div key={index} className='latestslidermaindiv'>
                                    <img src={ele.image[0]} className='latestsliderimg' alt="sliderimg" />
                                </div>
                            )
                        })}

                    </Slider>
                </div>

                {/* second slider  */}
                <div id='latestslider' className='latestslider'>
                    <div id='catslider2' className='subcatheadingdiv'>
                        <h2>Haldi ceremoney</h2>
                        <div className='catline'></div>
                    </div>
                    <Slider {...catsettings}>
                        {haldi.map((ele, index) => {
                            return (
                                <div key={index} className='latestslidermaindiv'>
                                    <img src={ele.image[0]} className='latestsliderimg' alt="sliderimg" />
                                </div>
                            )
                        })}

                    </Slider>
                </div>


                {/* third slider  */}

                <div id='latestslider' className='latestslider'>
                    <div id='catslider3' className='subcatheadingdiv'>
                        <h2>Mehendi</h2>
                        <div className='catline'></div>
                    </div>
                    <Slider {...catsettings}>
                        {mehendi.map((ele, index) => {
                            return (
                                <div key={index} className='latestslidermaindiv'>
                                    <img src={ele.image[0]} className='latestsliderimg' alt="sliderimg" />
                                </div>
                            )
                        })}

                    </Slider>
                </div>
            </div>


            <Footer />
        </>
    )
}

export default Catslider
